import type { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { legacyPlansOfStudyUrlToCanonical } from '@/routes/plan-of-study-legacy-url';

/** Single catch-all redirect for `plans-of-study/*` route trees. */
export function PlanOfStudyLegacyCatchAll(): ReactElement {
  const { pathname, search } = useLocation();
  const to = legacyPlansOfStudyUrlToCanonical(pathname, search);
  return <Navigate to={to} replace />;
}
